import { defineComponent as _defineComponent } from 'vue';
import { INFO_OUTLINE } from '@/constants/icons';
import { INTEGRATIONS } from '@/constants/packages';
export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    serviceType: {
      type: String,
      default: ''
    },
    services: {
      type: Array,
      default: () => []
    },
    availableServicesCount: {
      type: Number,
      default: 0
    },
    allowedIntegrationsCount: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const serviceSelectionInfo = () => {
      if (props.serviceType === INTEGRATIONS && props.allowedIntegrationsCount > 0) {
        const selectionLimit = props.availableServicesCount > props.allowedIntegrationsCount ? props.allowedIntegrationsCount : props.availableServicesCount;
        return `Please select up to ${selectionLimit} ${props.serviceType}.`;
      } else {
        return `Please select ${props.serviceType}.`;
      }
    };
    const selectedServicesText = () => {
      if (props.serviceType === INTEGRATIONS && props.allowedIntegrationsCount) {
        var _props$services;
        return `${((_props$services = props.services) === null || _props$services === void 0 ? void 0 : _props$services.length) || 0}/${props.availableServicesCount > props.allowedIntegrationsCount ? props.allowedIntegrationsCount : props.availableServicesCount} Selected`;
      } else {
        var _props$services2;
        return `${((_props$services2 = props.services) === null || _props$services2 === void 0 ? void 0 : _props$services2.length) || 0}/${props.availableServicesCount} Selected`;
      }
    };
    return {
      __sfc: true,
      props,
      serviceSelectionInfo,
      selectedServicesText,
      INFO_OUTLINE
    };
  }
});